import React from 'react';
import MiniHeader from '../components/MiniHeader';
import Team from '../components/Team';
import Blog from '../components/Blog';

const BlogPage = () => {
  return (
    <>
    <MiniHeader title={"Blog"} />
    <Blog />
    </>
  );
};

export default BlogPage;
